import { DefaultError, useMutation, useQuery } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IOwnerLogoResponse } from './types';

export const useGetOwnerLogo = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IOwnerLogoResponse, DefaultError>({
    queryKey: ['owner-logo'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Configuration/GetOwnerLogo`,
      });

      return responseHandler(response, {
        groupName: `useGetLicenceConfiguration`,
        onNotFound: () => {},
      });
    },
    retry: false,
  });
};

export const usePostOwnerLogo = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('usePostOwnerLogo');
  return useMutation<IOwnerLogoResponse, DefaultError, File>({
    mutationFn: async file => {
      loading(i18next.t('service-message.update.loading', { what: '' }));
      const formData = new FormData();

      formData.append('file', file);

      const response = await apiClient<FormData>({
        method: 'POST',
        url: `Configuration/SetOwnerLogo`,
        body: formData,
        // customContentType: 'multipart/form-data',
        withContentType: false,
      });

      return responseHandler(response, {
        groupName: 'usePostOwnerLogo',
      });
    },
    onSuccess: data => {
      success(i18next.t('service-message.update.success', { what: '' }));
    },
    onError: dismiss,
  });
};
